import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import React, { useEffect, useState } from "react";
import { getFaqDocumentBlob } from "../../../api/faqApi";

export const UserGuideTileContent = () => {
  // Fetched as a blob (see faqApi.ts) and turned into an object URL - a plain <a href>/<iframe src>
  // pointed straight at the backend's /faq/document/download wouldn't carry the bearer-token auth
  // every other call here needs. Revoked on unmount so the object URL doesn't leak.
  const [documentUrl, setDocumentUrl] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;

    getFaqDocumentBlob().then((blob) => {
      if (blob instanceof Blob) {
        objectUrl = URL.createObjectURL(blob);
        setDocumentUrl(objectUrl);
      }
    });

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, []);

  return (
    <>
      {documentUrl && (
        <>
          {/* "Open PDF" now genuinely opens in a new tab rather than downloading - the `download`
              attribute this used to also carry forces a save-to-disk regardless of target="_blank"
              (download always wins), which is the opposite of what a button labeled "Open" should
              do, especially with the iframe right below already previewing the same file inline.
              getFaqDocument()'s own file_name (fetched only to name that forced download) is no
              longer needed now that nothing downloads it by default. */}
          <a className="faq_button_primary" href={documentUrl} target="_blank" rel="noopener noreferrer">
            <PictureAsPdfOutlinedIcon fontSize="small" />
            Open PDF
          </a>
          <iframe className="faq_pdf_embed" src={documentUrl} title="CEDAR Home User Guide" />
        </>
      )}
    </>
  );
};
